module.exports = __webpack_public_path__ + "media/images/logo-4213637a3db0c77baffe3462148618dd.jpg";